import { useState, useEffect } from 'react';
import { ChatBubble } from './ChatBubble'
import { Box, Typography } from '@mui/material';

export const  ChatContainer = (options) => {
    const { messages } = options;

    return (
        <Box id="chatView" sx={{
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column-reverse', // Key for bottom alignment
            '& > div': {
              minHeight: 'min-content'
            }
          }}>
            {/* Messages in normal order (oldest first) */}
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              flex: 1
            }}>
              {messages.map(msg => (
                <ChatBubble 
                  key={msg.id}
                  isSender={msg.isSender}
                  content={msg.text}
                />
              ))}
            </Box>
          </Box>
    )
  }
  